/**
 * What each role may see and do on a Full Booking (v109 §5, §8, §11.9; Traci's review 23 Sep 2026, which is newer
 * where the two differ). One table, used by the server to decide what it returns and by the page to decide what it
 * shows (the page also applies it to Admin's View As simulation).
 *
 * Where Traci's review changed the handoff:
 *   Cancel Booking     Admin, Sales, Billing       (handoff: Admin + Billing)
 *   Assess Deduction   Admin, Billing              (handoff: + Editing, Talent; she corrected herself: Talent and
 *                                                   Editing raise a flag and tag Kendra instead)
 *   Client/Talent chat Admin, Talent only           (handoff agrees; the v108 prototype showed it to Editing)
 *   Update Stage       every role                  (Traci, 4 Oct 2026: "All roles can manually update pipeline")
 *   Job completion     Admin, Billing, Editing,    (handoff: no Billing; Traci's doc, Oct 2026: Billing sees them)
 *   forms              Talent
 */
const ROLES = ['admin', 'sales', 'billing', 'editing', 'talent_coordinator']

const RULES = {
  financial: ['admin', 'billing'],
  travel: ['admin', 'billing', 'talent_coordinator'],
  chat: ['admin', 'talent_coordinator'],
  // Traci, 27 Oct 2026: Admin and Talent Coordinator delete client / talent messages (hidden, kept; chatDelete.js)
  deleteChat: ['admin', 'talent_coordinator'],
  contract: ['admin', 'sales', 'billing'],
  bookingRecord: ['admin', 'billing'],
  questionnaires: ROLES,
  coi: ['admin', 'sales', 'talent_coordinator'],   // prototype v108 P 1880: Admin, Talent, Sales
  jcf: ['admin', 'billing', 'editing', 'talent_coordinator'],  // Traci's doc, Oct 2026: Billing sees job completion forms (v109 §5.2 had left them out)
  history: ['admin', 'sales', 'editing', 'talent_coordinator'],
  notes: ROLES,
  comms: ROLES,
  updateStage: ROLES,
  cancel: ['admin', 'sales', 'billing'],
  editDate: ['admin', 'sales'],
  assessDeduction: ['admin', 'billing'],
  // Traci's doc, Oct 2026: "Ability to set rates per booking. Permissions: admin, talent and billing."
  talentRates: ['admin', 'billing', 'talent_coordinator'],
  // Traci's Loom (28 Sep 2026): the Talent Payments button opens for Editing too; Editing, Talent and Billing flag the
  // deduction categories that apply with a note, and Billing settles them on Pay Talent (assessDeduction stays Billing)
  talentPayments: ['admin', 'billing', 'talent_coordinator', 'editing'],
  flagDeduction: ['admin', 'billing', 'talent_coordinator', 'editing']
}

/** Permissions for one role, or the union across several (a person may hold more than one role). */
export function bookingPermissions(roles) {
  const held = new Set((Array.isArray(roles) || roles instanceof Set ? [...roles] : [roles]).map(r => String(r || '').toLowerCase()))
  return Object.fromEntries(Object.entries(RULES).map(([k, allowed]) => [k, allowed.some(r => held.has(r))]))
}

export const PERMISSION_KEYS = Object.keys(RULES)
